<template>
  <div class="info-card" :style="{ maxWidth: `${maxWidth}px` }">
    <div
      class="info-card__title"
      :style="{
        backgroundColor: bgColorTitle,
        color: colorTitle,
        borderTopLeftRadius: `${borderRadius}px`,
        borderTopRightRadius: `${borderRadius}px`,
      }"
    >
      <v-icon class="title__icon" :style="{ color: colorTitle }">{{
        icon
      }}</v-icon>
      {{ title }}
    </div>
    <div
      class="info-card__content"
      :style="{
        border: `1px solid ${bgColorTitle}`,
        borderBottomLeftRadius: `${borderRadius}px`,
        borderBottomRightRadius: `${borderRadius}px`,
        fontWeight: fontWeightContent,
        fontSize: `${fontSizeContent}px`,
      }"
    >
      {{ content }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoCard',
  props: {
    maxWidth: { type: Number, default: 100 },
    icon: { type: String, default: 'mdi-chart-donut' },
    bgColorTitle: { type: String, default: '#e8f5fe' },
    colorTitle: { type: String, default: '#1098f7' },
    colorContent: { type: String, default: '#000' },
    borderRadius: { type: Number, default: 0 },
    title: { type: String, default: '' },
    content: { type: String, default: '' },
    fontWeightContent: { type: Number, default: 400 },
    fontSizeContent: { type: Number, default: 16 },
  },
};
</script>

<style lang="scss" scoped>
.info-card {
  .info-card__title {
    position: relative;
    padding: 12px;
    text-align: center;
  }
  .title__icon {
    position: absolute;
    left: 0;
    font-size: 25px;
    padding-left: 12px;
  }
  .info-card__content {
    font-size: 15px;
    padding: 10px;
    background-color: white;
    text-align: center;
  }
}
</style>
